module Meevo.Plugins.Resources {
    "use strict";

    /**
    * Main Section of Client 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Resource> {

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected trackingService?: Meevo.Components.Tracking.ITrackingService) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        private _activeState: boolean;
        private _selectedResourceCategory: Model.ResourceCategory;

        get activeState(): boolean {
            if (this.model !== undefined) {
                if (this.model.objectState === Model.ObjectStateEnum.Active) {
                    return true;
                }
            }

            return false;
        }

        createSectionModelCopy(): Model.Resource {
            let item = <Model.Resource>(this.model);
            item.id = null;
            return item;
        }

        capacityChanged() {
            if (this.model.capacity < 2) {
                this.model.canBeSplit = false;
            }
        }

        resourceCatChanged() {
            if (this.model !== undefined && this.model.resourceCategory !== undefined) {
                return this.getResourceCategory(this.model.resourceCategory.id).then((resourceCategory: Model.ResourceCategory) => {
                    this.model.foregroundColor = resourceCategory.foregroundColor;
                    this.model.backgroundColor = resourceCategory.backgroundColor;
                    this.model.services = resourceCategory.services;
                    this.model.resourceCategoryId = (resourceCategory.id as any);
                    this.model.resourceCategory.locationId = resourceCategory.locationId;
                    this.model.resourceCategory.homeLocationId = resourceCategory.homeLocationId;
                });
            }
        }

        getResourceCategory(resourceCatId: string) {
            return this.dataService.getSectionById("resourceCategory", new Guid(resourceCatId), "").then((data) => {
                this._selectedResourceCategory = data;
                return this._selectedResourceCategory;
            });
        }

        set activeState(value: boolean) {
            if (this.model !== undefined) {
                if (value) {
                    this.model.objectState = Model.ObjectStateEnum.Active;
                } else {
                    if (this.model.objectState !== Model.ObjectStateEnum.Deleted) {
                        this.model.objectState = Model.ObjectStateEnum.Inactive;
                    }
                }
            }
        }

        public sectionModelRetrieved(): void {
            if (this.model && this.model.resourceCategory) {
                this.getResourceCategory(this.model.resourceCategory.id);
            }
        }
        postCancel() {
            this.sectionModelRetrieved();
        }
        preSave() {
            if (this._selectedResourceCategory.foregroundColor == this.model.foregroundColor) {
                this.model.foregroundColor = "";
            }
            if (this._selectedResourceCategory.backgroundColor == this.model.backgroundColor) {
                this.model.backgroundColor = "";
            }        
        }

        preDelete = (context: any, items: any[], index: number): boolean => {
            const model = context.sections[0].model;
            const item = model.servicesResources.find(i => i.id == model.services[index].id);
            if (item !== undefined) {
                if (item.serviceStepTypeEnum == Meevo.Model.ServiceStepTypeEnum.Resource && item.resourceCount == 1) {
                    this.modalService.alert('MESSAGE_LAST_SERVICE_ON_RESOURCE', Meevo.Components.Modal.ModalTranslationModes.Translate).then(Response => Response)
                    return false;
                }
            }
            return true;
        }
    }

}